import React, { useState, useEffect }  from 'react';
import FormNew from './FormNew';
import { GetRequest, PostRequest } from 'components/common/index.js';
import styles from 'components/quote_builder_widget/settings/_style.module.scss';

const List = ( { defaultUnit = 'mm', defaultLanguageOption = 'en', widgetHost } ) => {
  const getInitialState = () => {
    const path = window.location.pathname;
    const editMatch = path.match(/\/quote-builder\/widgets\/([^/]+)\/edit/);
    if (editMatch) {
      return { mode: 'edit', identifier: editMatch[1] };
    }
    if (path.includes('/quote-builder/widgets/new')) {
      return { mode: 'new', identifier: '' };
    }
    return { mode: 'listing', identifier: '' };
  };

  const initialState = getInitialState();
  const [mode, setMode] = useState(initialState.mode)
  const [widgets, setWidgets] = useState([])
  const [identifier, setIdentifier] = useState(initialState.identifier)

  const widgetCard = (widget) => {
    return <div key={widget.identifier} className={styles.addedCard} data-testid="widget">
      <div className={styles.addedCardTitle}>{widget.identifier}</div>
      <div className={styles.addedCardDetails}>{t('quote_builder_widget.domains')}</div>
      <div className="attribute-properties">
        <div className="attribute-properties-row">
          { widget.domains.length > 0
            ? widget.domains.map((domain) => <span key={domain} className="attribute-tag">{domain}</span>)
            : <span className={styles.addedCardDetails}>{t('quote_builder_widget.installation_no_domains_short')}</span> }
        </div>
      </div>
      <div className={styles.addedCardActions}>
        <button type="button" className="dct-button dct-button--secondary dct-button--small" onClick={(e) => showEditForm(e, widget.identifier)}>
          <i className="fa fa-pencil" aria-hidden="true"></i>
          {t('quote_builder_widget.edit')}
        </button>
        <button type="button" className="dct-button dct-button--danger dct-button--small" onClick={(e) => deleteConfirm(e, widget.identifier)}>
          <i className="fa fa-trash" aria-hidden="true"></i>
          {t('quote_builder_widget.delete')}
        </button>
      </div>
    </div>
  }
  const listofItems = () => {
    return <div className={styles.widgetsListing}>
      <h4 className={styles.widgetsListingTitle}><span className="q-section-title">{t('quote_builder_widget.my_widgets')}</span></h4>
      { widgets.map(widgetCard) }
    </div>
  }

  const fetchWidgets = () => {
    if(mode != 'listing') { return }

    GetRequest({
      url: '/quote-builder/user-quote-builder-widgets',
      callback: (data) => {
        setWidgets( (_prev) => data );
      }
    })
  }

  const listofWidgets = () => {
    return (<>
      { widgets.length > 0 && listofItems() }

      { widgets.length == 0 && <div className="dct-empty-state">
        <i className="fa fa-code dct-empty-state__icon" aria-hidden="true"></i>
        <div className="dct-empty-state__action">
          <button type="button" onClick={showNewForm} className="dct-button dct-button--primary">
            <i className="fa fa-plus-square-o" aria-hidden="true"></i>
            {t('quote_builder_widget.new_widget')}
          </button>
        </div>
      </div> }
      </>)
  }

  const showEditForm = (e, widgetIdentifier) => {
    e.preventDefault();
    window.history.pushState({}, '', `/quote-builder/widgets/${widgetIdentifier}/edit`);
    setIdentifier(() => widgetIdentifier);
    setMode(() => 'edit');
  };

  const showNewForm = () => {
    window.history.pushState({}, '', '/quote-builder/widgets/new');
    setMode(() => 'new');
  };

  const goToListing = () => {
    window.history.pushState({}, '', '/quote-builder/widgets');
    setMode(() => 'listing');
  }

  const deleteConfirm = (e, identifier) => {
    if(confirm( t('quote_builder_widget.delete_widget_confirm') )) {

    PostRequest({
      url: '/quote-builder/user-quote-builder-widgets-delete',
      data: {
        identifier: identifier,
      },
      callback: ( data ) => {
        setMode( () => 'listing' )
        setIdentifier( () => '' )
        fetchWidgets();
      },
      400: (data) => {
        setErrorMessage( () => data.error )
      }
    })

    }
  }

  const handlePopState = () => {
    const newState = getInitialState();
    setMode(newState.mode);
    setIdentifier(newState.identifier);
  };

  // useEffect
  useEffect(fetchWidgets, [mode]);

  useEffect(() => {
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);
  // useEffect

  return (
    <div style={mode == 'listing' ? undefined : { marginLeft: '-20px' }}>
      {mode == 'listing' && listofWidgets()}
      {mode == 'new' && <FormNew setMode={goToListing} defaultUnit={defaultUnit} defaultLanguageOption={defaultLanguageOption} widgetHost={widgetHost} /> }
      {mode == 'edit' && <FormNew identifier={identifier} setMode={goToListing} defaultUnit={defaultUnit} defaultLanguageOption={defaultLanguageOption} widgetHost={widgetHost} /> }
    </div>
  )
}

export default List;
